import axios from 'axios';
import ConfigService from './config.service';
import { IVessel } from '../contracts/vessel.contract';

const getAll = async (): Promise<IVessel[]> => {
    const res = await axios.get(`${ConfigService.appConfig.baseApiUrl}/Vessel/ClientVessel`);
    return res.data;
};

const VesselService = {
    getAll
};

export default VesselService;
